export const filterIconButtonStyles = {
  padding: '2px',
  opacity: 0,
  transition: 'opacity 0.2s ease, color 0.2s ease',

  '&.filter-active': {
    opacity: 1,
    color: 'primary.main',
  },
};

export const popoverSlotProps = {
  paper: {
    sx: {
      borderRadius: '8px',
      boxShadow: ({ shadows }) => shadows[4],
      width: '260px',
    },
  },
};

export const anchorOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};

export const transformOrigin = {
  vertical: 'top',
  horizontal: 'left',
};

export const searchBoxStyles = {
  px: 1,
  pt: 1,
  pb: 0.5,
};

export const searchInputStyles = {
  width: '100%',
  fontSize: '13px',
  height: '32px',
  padding: '4px 8px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  outline: 'none',
  boxSizing: 'border-box',
};

export const selectedCountStyles = {
  px: 1.5,
  pb: 0.25,
};

export const menuListStyles = {
  maxHeight: 220,
  overflowY: 'auto',
  px: 0,
  py: 0.5,
};

export const menuItemStyles = {
  py: 0.25,
  px: 1.5,
  minHeight: 28,
  gap: 0.5,
};

export const menuControlStyles = {
  flexDirection: 'row',
  gap: 1,
  justifyContent: 'flex-end',
  px: 1.5,
  py: 1,
  borderTop: '1px solid',
  borderColor: 'divider',
};

export const optionCheckboxStyles = {
  p: 0,
  mr: 0.5,
  '& .MuiSvgIcon-root': {
    fontSize: '18px',
    fill: ({ palette }) => palette.border.filters,
  },
  '&.Mui-checked .MuiSvgIcon-root': {
    fill: ({ palette }) => palette.primary.main,
  },
};

const colorDotBaseStyles = {
  width: 10,
  height: 10,
  borderRadius: '50%',
  flexShrink: 0,
};

export const getColorDotStyles = bg => ({
  ...colorDotBaseStyles,
  backgroundColor: bg,
});

export const optionLabelStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const noResultsStyles = {
  py: 2,
  textAlign: 'center',
};

export const sectionDividerStyles = {
  my: 0.5,
};
